import { httpClient } from '@/lib/api/httpClient'
import type { Category, vendorType } from '@/shared/types'

export const categoryApi = {
  fetchCategories: async (vendorId: string): Promise<Category[]> => {
    const response = await httpClient.get(`/vendors/${vendorId}/categories`)
    const categories = response.data?.data?.categories ?? []
    return categories.sort((a: Category, b: Category) => a.name.localeCompare(b.name))
  },

  createCategory: async (vendorId: string, name: string, type: vendorType): Promise<Category[]> => {
    const response = await httpClient.post(`/vendors/${vendorId}/categories`, {
      vendorId,
      name: [name],
      type,
    })
    return response.data?.data?.categories ?? []
  },

  updateCategory: async (vendorId: string, categoryId: string, name: string): Promise<void> => {
    await httpClient.patch(`/vendors/${vendorId}/categories/${categoryId}`, { name })
  },

  deleteCategory: async (vendorId: string, categoryId: string): Promise<void> => {
    await httpClient.delete(`/vendors/${vendorId}/categories/${categoryId}`)
  },
}
